import React from 'react';
import { Main } from './components';

const CreateEdit = () => <Main />;

export default CreateEdit;
